export function normalizeEditableUrl(value, { allowEmpty = true } = {}) {
  const input = String(value ?? '').trim();
  if (!input && allowEmpty) return '';
  if (input.startsWith('/') && !input.startsWith('//')) return input;

  try {
    const url = new URL(input);
    if (url.protocol !== 'https:') throw new Error();
    return url.toString();
  } catch {
    throw new Error('Use um caminho interno iniciado por / ou uma URL HTTPS válida.');
  }
}

export function validateEditableUrls(values) {
  if (!values || typeof values !== 'object') return values;
  return Object.fromEntries(Object.entries(values).map(([key, value]) => {
    if ((key === 'url' || key.endsWith('_url')) && typeof value === 'string') {
      return [key, normalizeEditableUrl(value)];
    }
    if (key === 'social_links' && Array.isArray(value)) {
      return [key, value.map(item => normalizeEditableUrl(item, { allowEmpty: false }))];
    }
    return [key, value];
  }));
}
